<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    if (window.localStorage.getItem("hosName")) {
      document.title =
        "爱佑慈善基金会-" + window.localStorage.getItem("hosName");
    } else {
      document.title = "爱佑慈善基金会-医院端";
    }
  },
};
</script>

<style lang="scss">
@import "common/common";
.value-box {
  width: 9.375vw;
  font-size: 12px;
  height: 1.6vw;
  background-color: #f8f8f8;
  border: #d0d0d0 1px solid;
  line-height: 1.6vw;
  padding: 2px;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue